import { MouseEvent, ReactElement, ReactNode, useMemo } from 'react'

import { Color } from '../../enums/color'
import { LinkProps } from '../../types/linkProps'
import { getLinkProps } from '../../utils/getLinkProps'
import { Badge } from '../Badge'
import { Icon, IconName } from '../Icon'
import { Space } from '../Space'
import * as Styled from './styles'

export interface TabProps {
  active?: boolean
  badgeCounter?: number
  badgeLabel?: string
  children: ReactNode
  href?: string
  icon?: IconName
  onClick?: (event: MouseEvent<HTMLElement>) => void
  to?: string
}

export const Tab = ({
  badgeCounter = 0,
  badgeLabel,
  icon,
  children,
  active,
  href,
  to,
  onClick,
}: TabProps): ReactElement => {
  const linkProps: LinkProps | undefined = useMemo(
    () =>
      getLinkProps({
        href,
        to,
      }),
    [href, to],
  )

  return (
    <Styled.Tab active={active} onClick={onClick} {...linkProps}>
      {icon && (
        <Styled.IconWrapper>
          <Icon color={active ? Color.Grey950 : Color.Grey800} icon={icon} />
        </Styled.IconWrapper>
      )}
      {children}
      {badgeLabel && (
        <>
          <Space horizontal size="s8" />
          <Badge color="success" mode="subtle">
            {badgeLabel}
          </Badge>
        </>
      )}
      {badgeCounter > 0 && <Styled.BadgeCounter color="neutral">{badgeCounter}</Styled.BadgeCounter>}
    </Styled.Tab>
  )
}
